import { ChangeDetectionStrategy, Component, computed, inject, signal, input, ElementRef, AfterViewInit, effect } from '@angular/core';

import { ChatMessage, ChatRole } from '../../../models/agent.models';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { ConversationService } from '../../../services/conversation.service';
import { SkeletonModule } from 'primeng/skeleton';
import { ChatUserSettings } from '@dataclouder/ngx-core';

@Component({
  selector: 'dc-chat-messages-list',
  standalone: true,
  imports: [ChatMessageComponent, SkeletonModule],
  templateUrl: './chat-messages-list.component.html',
  styleUrls: ['./chat-messages-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessagesListComponent implements AfterViewInit {
  // Inputs
  readonly chatUserSettings = input.required<ChatUserSettings>();
  public inputMessages = input.required<ChatMessage[]>();
  // Private services
  private conversationService = inject(ConversationService);
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  // State
  public aiIcon: string = 'assets/defaults/avatar_ai.webp';
  isThinking = this.conversationService.isThinking();

  messages = computed(() => {
    // Get the actual array of messages from the signal by calling it as a function
    const allMessages = this.conversationService.getMessagesSignal()();
    console.log('Getting messages', allMessages);
    return allMessages.filter((message) => message.role !== ChatRole.System);
  });

  constructor() {
    effect(() => {
      // Access the messages to create a dependency
      const messages = this.messages(); // just to subscribe
      // Schedule the scroll after the view has been updated
      setTimeout(() => this.scrollToBottom(), 0);
    });
  }

  // Note probably i don't need this.
  ngAfterViewInit() {
    // Initial scroll to bottom when view is initialized
    this.scrollToBottom();
  }

  // Scroll to the bottom of the component itself with smooth animation
  scrollToBottom() {
    const element = this.elementRef.nativeElement;
    element.scrollTo({
      top: element.scrollHeight,
      behavior: 'smooth',
    });
  }

  // Track messages by their content and role for efficient rendering
  trackByMessage(index: number, message: ChatMessage): string {
    return `${message.role}-${index}-${message.content.substring(0, 20)}`;
  }
}
